module.exports = __webpack_public_path__ + "img/nav_profile.54bee85f.jpg";